import React from 'react';
import { connect } from 'react-redux';
import { clearUserProfile, setUserProfile } from '../redux/actions/user';
import { clearBugsnagUser, setBugsnagUser } from '../redux/actions/bugsnag';
import { setRedirectUri } from '../redux/actions/auth';
import { pageview, event } from '../redux/actions/google';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import LoginBar from './LoginBar.js';
import Alerts from '../prototypes/Alerts';
import Loadable from 'react-loadable';

//Accounting Components
import WholesaleCostList from '../content/accounting/cost/components/WSCostList';
import TransportCostList from '../content/accounting/transport/components/TransportCostList';
import ProgramInvoicesList from '../content/accounting/programinvoices/components/ProgramInvoices.js';
import ThirdPartyAdjustmentsList from '../content/accounting/thirdparty/components/ThirdPartyAdjustments';
import ThirdPartyLogsList from '../content/accounting/thirdparty/components/ThirdPartyLogs';
import EntityRevenueByDayList from '../content/accounting/thirdparty/components/EntityRevenueByDay';
import FeesList from '../content/enterprise/fees/components/FeesList'; // Previously in Enterprise
import Lp247GrossMedSalesList from '../content/accounting/lp247/components/Lp247GrossMedSalesList'; // Previously in Enterprise


// Enterprise Compoonents
import ANIAllTableSearchList from '../content/enterprise/anitables/components/ANIAllTableSearchList';
import AniTestingList from '../content/enterprise/anitables/components/AniTestingList';
import AniRouteList from '../content/enterprise/anitables/components/AniRouteList';
import AniExcludeList from '../content/enterprise/anitables/components/AniExcludeList';
import AniPermblockList from '../content/enterprise/anitables/components/AniPermblockList';
import ANISpoofList from '../content/enterprise/anitables/components/ANISpoofList';
import AniTraceList from '../content/enterprise/anitrace/components/AniTraceList';
import IvrFlowList from '../content/enterprise/ivrflow/components/IvrFlowList';
import IvrFlowAdsList from '../content/enterprise/ivrflowads/components/IvrFlowAdsList';
import VoiceFilesList from '../content/enterprise/voicefiles/components/VoiceFilesList';
import RateCallDataRulesList from '../content/enterprise/ratecalldatarules/components/RateCallDataRulesList';
import LeadGenList from '../content/enterprise/leadgen/components/LeadGenList';
import LeadGenNumbersList from '../content/enterprise/leadgennumbers/components/LeadGenNumbersList';
import ChangeManagementList from '../content/enterprise/changemanagement/components/ChangeManagementList';
import ProgramsList from '../content/enterprise/programs/components/ProgramsList';
import CanadaRoutingList from '../content/enterprise/canadarouting/components/CanadaRoutingList';
import PGMVoiceFilesList from '../content/enterprise/pgmvoicefiles/components/PGMVoiceFilesList';
import OnOffNetList from '../content/enterprise/onoffnet/components/OnOffnetList';
import PgmRetentionList from '../content/enterprise/pgmretention/components/PgmRetentionList';
import DialerDetection from '../content/enterprise/dialerdetection/components/DialerDetection';
import SpoofContainer from '../content/enterprise/spoof/components/SpoofContainer';
import CouponSummaryList from '../content/enterprise/couponsummary/components/CouponSummaryList';
import AdsPlayedByHourList from '../content/enterprise/glsdirectory/components/AdsPlayedByHourList';
import TransfersByHourList from '../content/enterprise/glsdirectory/components/TransfersByHourList';
import CallCountsReportList from '../content/enterprise/callcountsreport/components/CallCountsReportList';
import WSCallCountsList from '../content/enterprise/callcountsreport/components/WSCallCountsList';
import VendorInvoice from '../content/enterprise/invoice/components/VendorInvoice';
import WildcardFiltersList from '../content/enterprise/wildcards/components/WildcardFiltersList';
import WildcardGroupsList from '../content/enterprise/wildcards/components/WildcardGroupsList';
import WildcardPatternsList from '../content/enterprise/wildcards/components/WildcardPatternsList';
import WildcardNamesList from '../content/enterprise/wildcards/components/WildcardNamesList';
import RealTimeDataANISearchList from '../content/enterprise/realtimedata/components/ANISearchList';
import ASRRegexEditorList from '../content/enterprise/asr/components/ASRRegexEditorList';
import FileManagement from '../content/enterprise/filemanagement/components/FileManagement';
import SpeechTranscriptions from '../content/enterprise/speechtranscriptions/components/SpeechTranscriptions';

// Wholesale Components
import WholesaleCompanyList from '../content/wholesale/companies/components/CompanyList';
import WholesaleContactsList from '../content/wholesale/contacts/components/WholesaleContactsList';
import WholesaleNumbersList from '../content/wholesale/numbers/components/WholesaleNumbersList';
import WholesaleDefaultProgramsList from '../content/wholesale/defaultprograms/components/WholesaleDefaultProgramsList';
import WholesaleSIPInfoList from '../content/wholesale/sipinfo/components/WholesaleSIPInfoList';
import WholesaleSIPInboundList from '../content/wholesale/sipinbound/components/WholesaleSIPInboundList';
import WholesaleBrokerList from '../content/wholesale/brokers/components/WholsaleBrokerList';
import WholesalePaymentWorksheet from '../content/wholesale/payments/components/PaymentWorksheet';
import EOMReportSettings from '../content/wholesale/eomreportsettings/components/EOMReportSettings';
import WholesaleDashboard from '../content/wholesale/dashboard/components/WholesaleDashboard';
import WholesaleResporgsList from '../content/wholesale/resporgs/components/WholesaleResporgsList';
import WholesaleTFNSplitList from '../content/wholesale/tfnsplit/components/WholesaleTFNSplitList';

// Entities Components
import EntityClientsList from '../content/entities/clients/components/EntityClientsList';
import EntityContactsList from '../content/entities/contacts/components/EntityContactsList';
import EntityCentersList from '../content/entities/centers/components/EntityCentersList';
import EntityGatewaysList from '../content/entities/gateways/components/EntityGatewaysList';
import EntityNumbersList from '../content/entities/numbers/components/EntityNumbersList';
import EntityOffNetList from '../content/entities/offnet/components/EntityOffNetList';

// Reports Components
import ProductionReports from '../reports/ProductionReports';

// Dashboards Components
import ProgramsDashboardList from '../content/dashboards/programs/components/ProgramsDashboardList'; 
import WholesaleDashboardList from '../content/dashboards/wholesale/components/WholesaleDashboardList';
import GLSDirectoryDashboardList from '../content/dashboards/glsdirectory/components/GLSDirectoryDashboardList';
import TenMinuteReportsDashboardList from '../content/dashboards/10minutereports/components/10MinuteReportsDashboardList';
import CallsAttemptedServedDashboardList from '../content/dashboards/callsaattemptedserved/components/CallsAttemptedServedDashboardList';
import SipDashboards from '../content/dashboards/sip/components/SipDashboards';
                                               
// Documentation Components
import ApiDocumentationList from '../content/documentation/components/ApiDocumentationList';

// Technical Components
import DirectiveList from '../content/technical/directives/components/DirectiveList';
import DirectiveRuleList from '../content/technical/directives/components/DirectiveRuleList';
import DirectiveRulePropertyList from '../content/technical/directives/components/DirectiveRulePropertyList';
import SplitsList from '../content/technical/splits/splits/components/SplitsList';
import SplitsScheduleList from '../content/technical/splits/schedule/components/SplitsScheduleList';
import SplitsGroupList from '../content/technical/splits/group/components/SplitsGroupList';
import EnterprisePropertiesList from '../content/technical/properties/components/EnterprisePropertiesList';
import AlertsList from '../content/technical/alerts/alerts/components/AlertsList';
import AlertsEmailList from '../content/technical/alerts/email/components/AlertsEmailList';
import AlertsPersonnelList from '../content/technical/alerts/personnel/components/AlertsPersonnelList';
import AlertsTextCarrierList from '../content/technical/alerts/textcarrier/components/AlertsTextCarrierList';
import ServerRoutingList from '../content/technical/serverrouting/components/ServerRoutingList';
import EnterpriseDistributionSystemsList from '../content/technical/distributions/system/components/EnterpriseDistributionSystemsList';
import EnterpriseDistributionsList from '../content/technical/distributions/distribution/components/EnterpriseDistributionsList';
import ASRTestScheduleList from '../content/technical/asr/components/ASRTestSchedule';
import TypeCodecTypeList from '../content/technical/support/components/TypeCodecTypeList';
import TypeFeeTypeList from '../content/technical/support/components/TypeFeeTypeList';
import TypeFeeBaseList from '../content/technical/support/components/TypeFeeBaseList';
import TypeFeeStateList from '../content/technical/support/components/TypeFeeStateList';
import PgmGroupRuleList from '../content/technical/support/components/PgmGroupRuleList';
import TypeAdTypeList from '../content/technical/support/components/TypeAdTypeList';
import TypeRiskTypeList from '../content/technical/support/components/TypeRiskTypeList';
import TypeRoutingTypeList from '../content/technical/support/components/TypeRoutingTypeList';
import TypeDnisTypeList from '../content/technical/support/components/TypeDnisTypeList';
import TypeDnisTypeSummList from '../content/technical/support/components/TypeDnisTypeSummList';
import TypeTrafficTypeList from '../content/technical/support/components/TypeTrafficTypeList';
import CountrycodesList from '../content/technical/support/components/CountrycodesList';
import TypeTimeZoneList from '../content/technical/support/components/TypeTimeZoneList';
import TypeVoiceTypeList from '../content/technical/support/components/TypeVoiceTypeList';
import TypeWsRouteCanadaTypeList from '../content/technical/support/components/TypeWsRouteCanadaTypeList';
import EntityTypeList from '../content/technical/support/components/EntityTypeList';
import ProgramsDynamicStatementVariablesList from '../content/technical/support/components/ProgramsDynamicStatementVariablesList.js';
import AudioManagementSystem from '../content/technical/audiomgmt/components/AMS';
import JobsList from '../content/technical/jobs/components/JobsList';
import DipServicesList from '../content/technical/dipservices/components/DipServicesList';
import DipServicesAlertsList from '../content/technical/dipservices/components/DipServicesAlertsList';

// Admin Components
import SitePingerLogsList from '../content/admin/sitepingerlogs/components/SitePingerLogsList';
import SitePingerList from '../content/admin/sitepinger/components/SitePingerList';
import ApiLogsList from '../content/admin/apilogs/components/ApiLogsList';
import UsersList from '../content/admin/users/components/UsersList';
import GroupsList from '../content/admin/groups/components/GroupsList';
import PermissionsList from '../content/admin/permissions/components/PermissionsList';
import MenusList from '../content/admin/menus/components/MenusList';
import AdminReportsList from '../content/admin/reports/components/Reports';
import AdminReportsGroupsList from '../content/admin/reports/components/Groups';
import AdminReportsPermissionsList from '../content/admin/reports/components/Permissions';
import AdminTestFeatures from '../content/admin/admintest/adminTestFeatures';

// Logo
import ColorLogoTransparentWhite from '../imgs/color_logo_transparent_white.svg';

// Navigation
import {
  Navbar,
  NavbarItem,
  MenuItem
} from './Navigation';

const ui_version = "2.0.0.0";

const LoadableError404 = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableError404" */ '../views/Error404.js' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableHomePage = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableHomePage" */ '../views/Home.js' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableLoginForm = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableLoginForm" */ '../views/LoginForm.js' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableSetPasswordForm = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableSetPasswordForm" */ '../views/SetPasswordForm.js' ),
  loading: () => <div> LOADING </div>,
} );


const LoadableResetPasswordForm = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableResetPasswordForm" */ '../views/ResetPasswordForm.js' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableCookiePolicy = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableCookiePolicy" */ '../views/CookiePolicy' ),
  loading: () => <div> LOADING </div>,
} );

const LoadablePrivacyPolicy = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadablePrivacyPolicy" */ '../views/PrivacyPolicy' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableUserProfile = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableUserProfile" */ '../views/UserProfile' ),
  loading: () => <div> LOADING </div>,
} );


const LoadableChangeManagementLogs = Loadable( {
  loader: () => import( /* webpackChunkName: "ChangeManagementLogsChunk" */ '../content/enterprise/changemanagement/components/ChangeManagementLogs' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableTFNShield = Loadable( {
  loader: () => import( /* webpackChunkName: "TFNShieldChunk" */ '../content/technical/tfnshield/components/TFNShield' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableDefaultPrograms = Loadable( {
  loader: () => import( /* webpackChunkName: "DefaultProgramsChunk" */ '../content/enterprise/defaultprograms/components/DefaultPrograms' ),
  loading: () => <div> LOADING </div>,
} );

class Container extends React.Component {
  constructor( props ) {
    super( props );
    this.lastroute = '';
    this.state = {
      auth: this.props.auth,
      menus: [],
      updated: false,
      menuOpen: false,
      newContent: false,
      sidebarCollapsed: this.getSidebarCollapsed(),
      submenuOpen: {}
    };

    // Bindings
    this.onMenuClick = this.onMenuClick.bind( this );
    this.onSubMenuClick = this.onSubMenuClick.bind( this );
    this.onResizeContainer = this.onResizeContainer.bind( this );
  }

  componentDidMount() {
    window.addEventListener( 'newContentAvailable', this.onNewContentAvailable );
    window.addEventListener( 'resize', this.onResizeContainer );
    const auth = this.props.auth;
    const history = this.props.history;
    this.lastroute = history.location.pathname;

    if ( this.isStaticRoute() === false ) {
      if ( auth === undefined ) {
        this.gotoLogin();
        return;
      } else {
        if ( auth.loggedIn() === false ) {
          if( history.location.pathname !== '/login' ) {
            this.saveRedirect( history.location.pathname );
          }
          this.gotoLogin();
          return;
        } else {
          this.loadUser();
        }
      }
    } else {
      if( auth.loggedIn() === true ) {
        this.gotoHome();
      }
    }
  }

  componentWillUnmount(){
    window.removeEventListener( 'newContentAvailable', this.onNewContentAvailable );
    window.removeEventListener( 'resize', this.onResizeContainer );
  }

  componentWillReceiveProps( nextProps ) {
    const auth = nextProps.auth;
    const user = nextProps.user === undefined ? { 'profile': '' } : nextProps.user;
    const history = this.props.history;
    this.recordPage();
    this.lastroute = history.location.pathname;
    if( this.state.newContent === true ) {
      this.setState( {
        newContent: false
      } , window.location.reload() );
    }
    if( auth.loggedIn() === true ) {
      if ( user.profile === '' ) {
        this.loadUser();
      } 
    }
  }
  
  recordPage() {
    const { dispatch } = this.props;
    const history = this.props.history;
    dispatch( pageview( history.location.pathname ) );
  }

  onNewContentAvailable = ( ) => {
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    alerts.WARNING( 'New Content Available', { 'statusText': 'We have detected that new changes are available. Please refresh this page at your earliest convenience.' } );
    this.setState( { 
      newContent: true
    } );
  }

  saveRedirect( route ) {
    const { dispatch } = this.props;
    dispatch( setRedirectUri( route ) );
  }

  // Closes any open menus (desktop to mobile bug fix)
  onResizeContainer(){
    this.setState( {
      menuOpen: false,
      submenuOpen: {}
    } );
  }

  isStaticRoute() {
    const history = this.props.history;
    const pathname = history.location.pathname;
    const views = [
      '/',
      '/login',
      '/setpassword',
      '/resetpassword',
      '/privacypolicy',
      '/cookiepolicy'
    ];
    for ( var index = 0; index < views.length; index++ ) {
      if ( pathname === views[index] ) {
        return true;
      }
    }
    return false;
  }

  onMenuClick( e ) {
    const { history, auth, bugsnag, dispatch } = this.props;
    const route = e.target.route;
    const alerts = new Alerts( bugsnag, dispatch );
    if( auth.isTokenExpired() === false ) {
      dispatch( setRedirectUri( route ) );
      if ( history !== undefined ) {
        if ( route !== undefined ) {
          if( route !== this.lastroute ) {
            this.lastroute = route;
            history.push( route );
          }
        }
      } else {
        this.gotoHome();
      }
  
      this.setState( {
        menuOpen: !this.state.menuOpen
      } );
    } else {
      this.doLogOff();
      alerts.INFO('Session expired', "Your session has expired.", 5000 );
    }
  }

  doLogOff() {
    const { dispatch, auth } = this.props;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  loadUser() {
    const auth = this.props.auth;
    const idToken = auth.getToken();
    const bugsnag = this.props.bugsnag;
    const dispatch = this.props.dispatch;
    const alerts = new Alerts( bugsnag, dispatch );

    if ( auth.loggedIn() === false ) {
      this.doLogOff();
      return;
    }

    const clientId = auth.ClientId;
    const userInfo = auth.getUserInfo();

    auth.getUserGroups( clientId, idToken ).then( ( usergroups ) => {
      auth.getUserMenus().then( ( usermenus ) => {

        userInfo.userGroups = usergroups;
        userInfo.userMenus = usermenus;
        userInfo.userCompany = userInfo.company_id;

        dispatch( setUserProfile( userInfo ) );

        const bugsnagUser = {
          name: userInfo.nickname,
          email: userInfo.email,
          company_id: userInfo.userCompany
        };

        dispatch( event( 'Authentication','User Event','SIGN ON: ' +  userInfo.name))

        dispatch( setBugsnagUser( bugsnagUser ) );

        this.setState( {
          menus: usermenus,
        } );

      } ).catch( ( exception ) => {

        alerts.WARNING( 'User Menu Authorization', exception, 15000 );

        this.doLogOff();

      } );

    } ).catch( ( exception ) => {

      alerts.WARNING( 'User Groups Authorization', exception, 15000 );

      this.doLogOff();

    } );
  }

  gotoLogin() {
    const history = this.props.history;
    if( history !== undefined ) {
      history.push( '/login' );
    }
  }

  gotoHome() {
    const history = this.props.history;
    if( history !== undefined ) {
      history.push( '/home' );
    }
  }

  onSubMenuClick( key ) {
    let open = !this.state.submenuOpen[key];
    let submenuOpen = {};
    submenuOpen[key] = open;

    this.setState( {
      submenuOpen: submenuOpen
    } );
  }

  getSidebarCollapsed() {
    if( localStorage !== undefined && localStorage !== null ) {
      let isSidebarCollapsed = localStorage.getItem( 'sidebar-collapsed' );
      if( ( isSidebarCollapsed !== null ) && ( isSidebarCollapsed !== undefined ) ) {
        if( isSidebarCollapsed.toLowerCase() === 'true' || isSidebarCollapsed === true ) {
          return true;
        }
      }
    }
    return false;
  }

  saveSidebarCollapsed( collapsed ) {
    if( localStorage !== undefined && localStorage !== null ) {
      if( collapsed === true ) {
        localStorage.setItem( 'sidebar-collapsed', 'true' );
      } else {
        localStorage.setItem( 'sidebar-collapsed','false' );
      }
    }
  }

  onRenderMenu() {
    const auth = this.props.auth;

    if ( auth.loggedIn() === true ) {
      let menus = [];
      const parentmenus = this.state.menus;
      if ( parentmenus !== undefined ) {
        if ( parentmenus.length > 0 ) {
          for ( let parentindex = 0; parentindex < parentmenus.length; parentindex++ ) {
            let parentmenu = parentmenus[parentindex];
            let childmenus = [];
            if ( parentmenu !== undefined ) {
              if ( parentmenu.menuitems !== undefined ) {
                const menuitems = parentmenu.menuitems;
                if ( menuitems.length > 0 ) {
                  for ( let childindex = 0; childindex < menuitems.length; childindex++ ) {
                    let childmenu = menuitems[childindex];
                    const childMenuItem = ( <MenuItem key={childmenu.MENU_KEY} caption={childmenu.MENU_CAPTION} route={childmenu.MENU_ROUTE} onClick={this.onMenuClick} /> );
                    childmenus.push( childMenuItem );
                  } //for( let childindex = 0; childindex < menuitems.length; childindex++ ) {
                } //if( menuitems.length > 0 )
              } //if( parentmenu.menuitems !== undefined )
              const parentMenuItem = (
                <NavbarItem key={parentmenu.MENU_KEY} caption={parentmenu.MENU_CAPTION} icon={parentmenu.MENU_ICON} parentindex={parentindex} submenuOpen={this.state.submenuOpen[parentindex]} setOpen={this.onSubMenuClick}>
                  {childmenus}
                </NavbarItem>
              );
              menus.push( parentMenuItem );
            } //for( let parentindex = 0; parentindex < parentmenus.length; parentindex++ )
          } // if( parentmenus.length > 0 )
        } //if( parentmenus !== undefined ) {
      } //if( auth.loggedIn() === true )
      const location = window.location.hostname;
      let environment = `sandbox v${ui_version}`;
      if( location === 'etelconnections.com' ) {
        environment = `production v${ui_version}`;
      } else if( location === 'www.etelconnections.com' ) {
        environment = `production`;
      } else if( location === 'dev.etelconnections.com' ) {
        environment =`staging v${ui_version}`;
      } else {
        environment = `sandbox v${ui_version}`;
      }
      return (
        <span className="main-container-header sidebar-menu-container">
          <span className="sidebar-collapse-env">
            {environment}
          </span>
          <span className="sidebar-collapse-button" onClick={() => {
            const collapsed = !this.getSidebarCollapsed();
            this.setState( {
              sidebarCollapsed: collapsed
            }, () => this.saveSidebarCollapsed( collapsed ) );
          }}></span>
          <span className="sidebar-menu-logo-wrapper">
            <a href="/home">
              <img className="sidebar-menu-logo" src={ColorLogoTransparentWhite} alt="Etel Connections, LLC" />
            </a>
          </span>
          <i className={ ( this.state.menuOpen ) ? 'icon-fontello-menu-3 hamburger-menu open' : 'icon-fontello-menu-3 hamburger-menu' } onClick={()=>{
            this.setState( {
              menuOpen: !this.state.menuOpen
            } );
          }}></i>
          <span className="menubar">
            <Navbar>
              {menus}
            </Navbar>
          </span>
          <LoginBar />
        </span>
      );
    } else {
      return ( <span></span> );
    }
  }

  onRenderBody() {
    const auth = this.props.auth;
    if ( auth.loggedIn() === true ) {
      return (
        <span className="main-container-body">
          <Switch>
            
            <Redirect from="/home/*" to="/home" />
            <Redirect from="/user/profile/*" to="/user/profile" />

            {/* STATIC ROUTES */}
            <Route path="/home" component={LoadableHomePage} />
            <Route path="/user/profile" component={LoadableUserProfile} />
            <Route path="/404" component={LoadableError404} />

            { /* ACCOUNTING REDIRECTS */}
            <Redirect from="/accounting/wholesalecost/*" to="/accounting/wholesalecost" />
            <Redirect from="/accounting/transportcost/*" to="/accounting/transportcost" />
            <Redirect from="/accounting/programinvoices/*" to="/accounting/programinvoices" />
            <Redirect from="/accounting/fees/*" to="/accounting/fees" />
            <Redirect from="/accounting/thirdparty/adjustments/*" to="/accounting/thirdparty/adjustments" />
            <Redirect from="/accounting/thirdparty/logs/*" to="/accounting/thirdparty/logs" />
            <Redirect from="/accounting/thirdparty/entityrevenuebyday/*" to="/accounting/thirdparty/entityrevenuebyday" />

            {/* ACCOUNTING EXACT ROUTES */}
            <Route exact path="/accounting/wholesalecost" component={WholesaleCostList} />
            <Route exact path="/accounting/transportcost" component={TransportCostList} />
            <Route exact path="/accounting/programinvoices" component={ProgramInvoicesList} />
            <Route exact path="/accounting/fees" component={FeesList} />
            <Route exact path="/accounting/thirdparty/adjustments" component={ThirdPartyAdjustmentsList} />
            <Route exact path="/accounting/thirdparty/logs" component={ThirdPartyLogsList} />
            <Route exact path="/accounting/thirdparty/entityrevenuebyday" component={EntityRevenueByDayList} />
            <Route exact path="/accounting/lp247/sales" component={Lp247GrossMedSalesList} />
            <Redirect from="/accounting/*" to="/404" />

            { /* ENTERPRISE REDIRECTS */}
            <Redirect from="/enterprise/allanitables/*" to="/enterprise/allanitables" />
            <Redirect from="/enterprise/anitesting/*" to="/enterprise/anitesting" />
            <Redirect from="/enterprise/aniroute/*" to="/enterprise/aniroute" />
            <Redirect from="/enterprise/aniexclude/*" to="/enterprise/aniexclude" />
            <Redirect from="/enterprise/anipermblock/*" to="/enterprise/anipermblock" />
            <Redirect from="/enterprise/anitrace/*" to="/enterprise/anitrace" />
            <Redirect from="/enterprise/asr/regex/editor/*" to="/enterprise/asr/regex/editor" />
            <Redirect from="/enterprise/ivrflows/ads/*" to="/enterprise/ivrflows/" />
            <Redirect from="/enterprise/ivrflows/voicefiles/*" to="/enterprise/ivrflows/voicefiles" />
            <Redirect from="/enterprise/ratecalldatarules/*" to="/enterprise/ratecalldatarules" />
            <Redirect from="/enterprise/leadgen/*" to="/enterprise/leadgen/" />
            <Redirect from="/enterprise/leadgennumbers/*" to="/enterprise/leadgennumbers/" />
            <Redirect from="/enterprise/changemanagement/*" to="/enterprise/changemanagement" />
            <Redirect from="/enterprise/changemanagementlogs/*" to="/enterprise/changemanagementlogs" />
            <Redirect from="/enterprise/programs/*" to="/enterprise/programs" />
            <Redirect from="/enterprise/voicefiles/*" to="/enterprise/voicefiles" />
            <Redirect from="/enterprise/onoffnet/*" to="/enterprise/onoffnet" />
            <Redirect from="/enterprise/pgmretention/*" to="/enterprise/pgmretention" />
            <Redirect from="/enterprise/dialerdetection/*" to="/enterprise/dialerdetection" />
            <Redirect from="/enterprise/spoof/*" to="/enterprise/spoof" />
            <Redirect from="/enterprise/couponsummary/*" to="/enterprise/couponsummary" />
            <Redirect from="/enterprise/glsdirectory/adsplayedbyhour/*" to="/enterprise/glsdirectory/adsplayedbyhour" />
            <Redirect from="/enterprise/glsdirectory/transfersbyhour/*" to="/enterprise/glsdirectory/transfersbyhour" />
            <Redirect from="/enterprise/callcountsreport/*" to="/enterprise/callcountsreport" />
            <Redirect from="/enterprise/wscallcounts/*" to="/enterprise/wscallcounts" />
            <Redirect from="/enterprise/invoice/*" to="/enterprise/invoice" />
            <Redirect from="/enterprise/canadarouting/*" to="/enterprise/canadarouting" />
            <Redirect from="/enterprise/defaultprograms/*" to="/enterprise/defaultprograms" />
            <Redirect from="/enterprise/wildcards/patterns/*" to="/enterprise/wildcards/patterns" />
            <Redirect from="/enterprise/wildcards/filters/*" to="/enterprise/wildcards/filters" />
            <Redirect from="/enterprise/wildcards/names/*" to="/enterprise/wildcards/names" />
            <Redirect from="/enterprise/wildcards/groups/*" to="/enterprise/wildcards/groups" />
            <Redirect from="/enterprise/filemanagement/*" to="/enterprise/filemanagement" />
            <Redirect from="/enterprise/speechtranscriptions/*" to="/enterprise/speechtranscriptions" />

            { /* ENTERPRISE EXACT ROUTES */}
            <Route exact path="/enterprise/allanitables" component={ANIAllTableSearchList} />
            <Route exact path="/enterprise/anitesting" component={AniTestingList} />
            <Route exact path="/enterprise/aniroute" component={AniRouteList} />
            <Route exact path="/enterprise/aniexclude" component={AniExcludeList} />
            <Route exact path="/enterprise/anipermblock" component={AniPermblockList} />
            <Route exact path="/enterprise/anispoof" component={ANISpoofList} />
            <Route exact path="/enterprise/anitrace" component={AniTraceList} />
            <Route exact path="/enterprise/asr/regex/editor" component={ASRRegexEditorList} />
            <Route exact path="/enterprise/ivrflows" component={IvrFlowList} />
            <Route exact path="/enterprise/ivrflows/ads" component={IvrFlowAdsList} />
            <Route exact path="/enterprise/ivrflows/voicefiles" component={VoiceFilesList} />
            <Route exact path="/enterprise/ratecalldatarules" component={RateCallDataRulesList} />
            <Route exact path="/enterprise/leadgen" component={LeadGenList} />
            <Route exact path="/enterprise/leadgennumbers" component={LeadGenNumbersList} />
            <Route exact path="/enterprise/changemanagement" component={ChangeManagementList} />
            <Route exact path="/enterprise/changemanagementlogs" component={LoadableChangeManagementLogs} />
            <Route exact path="/enterprise/programs" component={ProgramsList} />
            <Route exact path="/enterprise/voicefiles" component={PGMVoiceFilesList} />
            <Route exact path="/enterprise/onoffnet" component={OnOffNetList} />
            <Route exact path="/enterprise/pgmretention" component={PgmRetentionList} />
            <Route exact path="/enterprise/dialerdetection" component={DialerDetection} />
            <Route exact path="/enterprise/spoof" component={SpoofContainer} />
            <Route exact path="/enterprise/couponsummary" component={CouponSummaryList} />
            <Route exact path="/enterprise/glsdirectory/adsplayedbyhour" component={AdsPlayedByHourList} />
            <Route exact path="/enterprise/glsdirectory/transfersbyhour" component={TransfersByHourList} />
            <Route exact path="/enterprise/callcountsreport" component={CallCountsReportList} />
            <Route exact path="/enterprise/wscallcounts" component={WSCallCountsList} />
            <Route exact path="/enterprise/invoice" component={VendorInvoice} />
            <Route exact path="/enterprise/canadarouting" component={CanadaRoutingList} />
            <Route exact path="/enterprise/defaultprograms" component={LoadableDefaultPrograms} />
            <Route exact path="/enterprise/wildcards/patterns" component={WildcardPatternsList} />
            <Route exact path="/enterprise/wildcards/filters" component={WildcardFiltersList} />
            <Route exact path="/enterprise/wildcards/names" component={WildcardNamesList} />
            <Route exact path="/enterprise/wildcards/groups" component={WildcardGroupsList} />
            <Route exact path="/enterprise/realtimedata/anisearch" component={RealTimeDataANISearchList} />
            <Route exact path="/enterprise/filemanagement" component={FileManagement} />
            <Route exact path="/enterprise/speechtranscriptions" component={SpeechTranscriptions} />
            <Redirect from="/enterprise/*" to="/404" />

            { /* WHOLESALE REDIRECTS */ }
            <Redirect from="/wholesale/companies/*" to="/wholesale/companies" />
            <Redirect from="/wholesale/contacts/*" to="/wholesale/contacts"/>
            <Redirect from="/wholesale/numbers/*" to="/wholesale/numbers"/>
            <Redirect from="/wholesale/defaultprograms/*" to="/wholesale/defaultprograms"/>
            <Redirect from="/wholesale/sipinfo/*" to="/wholesale/sipinfo"/>
            <Redirect from="/wholesale/sipinbound/*" to="/wholesale/sipinbound" />
            <Redirect from="/wholesale/brokers/*" to="/wholesale/brokers" />
            <Redirect from="/wholesale/payments/*" to="/wholesale/payments" />
            <Redirect from="/wholesale/eomreportsettings/*" to="/wholesale/eomreportsettings" />
            <Redirect from="/wholesale/dashboard/*" to="/wholesale/dashboard" />
            <Redirect from="/wholesale/resporgs/*" to="/wholesale/resporgs" />
            <Redirect from="/wholesale/tfnsplit/*" to="/wholesale/tfnsplit" />


            { /* WHOLESALE EXACT ROUTES */}
            <Route exact path="/wholesale/companies" component={WholesaleCompanyList} />
            <Route exact path="/wholesale/contacts" component={WholesaleContactsList} />
            <Route exact path="/wholesale/numbers" component={WholesaleNumbersList} />
            <Route exact path="/wholesale/defaultprograms" component={WholesaleDefaultProgramsList} />
            <Route exact path="/wholesale/sipinfo" component={WholesaleSIPInfoList} />
            <Route exact path="/wholesale/sipinbound" component={WholesaleSIPInboundList} />
            <Route exact path="/wholesale/brokers" component={WholesaleBrokerList} />
            <Route exact path="/wholesale/payments" component={WholesalePaymentWorksheet} />
            <Route exact path="/wholesale/eomreportsettings" component={EOMReportSettings} />
            <Route exact path="/wholesale/dashboard" component={WholesaleDashboard} />
            <Route exact path="/wholesale/resporgs" component={WholesaleResporgsList} />
            <Route exact path="/wholesale/tfnsplit" component={WholesaleTFNSplitList} />
            <Redirect from="/wholesale/*" to="/404" />

            {/* ENTITY REDIRECTS */}
            <Redirect from="/entities/clients/*" to="/entities/clients"/>
            <Redirect from="/entities/contacts/*" to="/entities/contacts" />
            <Redirect from="/entities/centers/*" to="/entities/centers" />
            <Redirect from="/entities/gateways/*" to="/entities/gateways" />
            <Redirect from="/entities/numbers/*" to="/entities/numbers" />
            <Redirect from="/entities/offnet/*" to="/entities/offnet" />

            {/* ENTITY EXACT ROUTES */}
            <Route exact path="/entities/clients" component={EntityClientsList} />
            <Route exact path="/entities/contacts" component={EntityContactsList} />
            <Route exact path="/entities/centers" component={EntityCentersList} />
            <Route exact path="/entities/gateways" component={EntityGatewaysList} />
            <Route exact path="/entities/numbers" component={EntityNumbersList} />
            <Route exact path="/entities/offnet" component={EntityOffNetList} />
            <Redirect from="/entities/*" to="/404" />

            { /* REPORTS ROUTES */ }
            <Route exact path="/reports/production" component={ProductionReports} />
            <Route path="/reports/production/*" component={ProductionReports} />
            
            {/* DASHBOARD REDIRECTS */}
            <Redirect from="/dashboards/coupons/*" to="/dashboards/coupons"/>
            <Redirect from="/dashboards/wholesale/*" to="/dashboards/wholesale" />
            <Redirect from="/dashboards/glsdirectory/*" to="/dashboards/glsdirectory" />
            <Redirect from="/dashboards/10minutereports/*" to="/dashboards/10minutereports" />
            <Redirect from="/dashboards/callsattemptedserved/*" to="/dashboards/callsattemptedserved" />
            <Redirect from="/dashboards/sip/*" to="/dashboards/sip" />

            { /* DASHBOARDS ROUTES */}
            <Route exact path="/dashboards/coupons" component={ProgramsDashboardList} />
            <Route exact path="/dashboards/wholesale" component={WholesaleDashboardList} />
            <Route exact path="/dashboards/gls" component={GLSDirectoryDashboardList} />
            <Route exact path="/dashboards/10minutereports" component={TenMinuteReportsDashboardList} />
            <Route exact path="/dashboards/callsattemptedserved" component={CallsAttemptedServedDashboardList} />
            <Route exact path="/dashboards/sip" component={SipDashboards} />
            <Redirect from="/dashboards/*" to="/404" />

            { /* API DOCUMENTATION ROUTES */ }
            <Route exact path="/docs/api" component={ApiDocumentationList} />
            <Redirect from="/docs/*" to="/404" />

            { /* TECHNICAL REDIRECTS */ }
            <Redirect from="/technical/directives/rules/properties/*" to="/technical/directives/rules/properties" />
            <Redirect from="/technical/enterpriseproperties/*" to="/technical/enterpriseproperties" />
            <Redirect from="/technical/splits/schedule/*" to="/technical/splits/schedule" />
            <Redirect from="/technical/splits/group/*" to="/technical/splits/group" />
            <Redirect from="/technical/tfnshield/*" to="/technical/tfnshield" />
            <Redirect from="/technical/alerts/email/*" to="/technical/alerts/email" />
            <Redirect from="/technical/alerts/personnel/*" to="/technical/alerts/personnel" />
            <Redirect from="/technical/alerts/textcarrier/*" to="/technical/alerts/textcarrier" />
            <Redirect from="/technical/serverrouting/*" to="/technical/serverrouting" />
            <Redirect from="/technical/distribution/systems/*" to="/technical/distribution/systems" />
            <Redirect from="/technical/codectypes/*" to="/technical/codectypes" />
            <Redirect from="/technical/feetypes/*" to="/technical/feetypes" />
            <Redirect from="/technical/feebases/*" to="/technical/feebases" />
            <Redirect from="/technical/feestates/*" to="/technical/feestates" />
            <Redirect from="/technical/programgrouprules/*" to="/technical/programgrouprules" />
            <Redirect from="/technical/risktypes/*" to="/technical/risktypes/" />
            <Redirect from="/technical/adtypes/*" to="/technical/adtypes/" />
            <Redirect from="/technical/routingtypes/*" to="/technical/routingtypes/" />
            <Redirect from="/technical/dnistypes/*" to="/technical/dnistypes/" />
            <Redirect from="/technical/dnistypesummary/*" to="/technical/dnistypesummary" />
            <Redirect from="/technical/traffictypes/*" to="/technical/traffictypes" />
            <Redirect from="/technical/countrycodes/*" to="/technical/countrycodes" />
            <Redirect from="/technical/timezones/*" to="/technical/timezones" />
            <Redirect from="/technical/voicetypes/*" to="/technical/voicetypes" />
            <Redirect from="/technical/canadaroutetypes/*" to="/technical/canadaroutetypes" />
            <Redirect from="/technical/entitytypes/*" to="/technical/entitytypes" />
            <Redirect from="/technical/dynamicstatementvariables/*" to="/technical/dynamicstatementvariables" />
            <Redirect from="/technical/jobs/*" to="/technical/jobs" />
            <Redirect from="/technical/dipservices/alerts/*" to="/technical/dipservices/alerts" />

            { /* TECHNICAL ROUTES */ }
            <Route exact path="/technical/directives" component={DirectiveList} />
            <Route exact path="/technical/directives/rules" component={DirectiveRuleList} />
            <Route exact path="/technical/directives/rules/properties" component={DirectiveRulePropertyList} />
            <Route exact path="/technical/enterpriseproperties" component={EnterprisePropertiesList} />
            <Route exact path="/technical/splits" component={SplitsList} />
            <Route exact path="/technical/splits/schedule" component={SplitsScheduleList} />
            <Route exact path="/technical/splits/group" component={SplitsGroupList} />
            <Route exact path="/technical/tfnshield" component={LoadableTFNShield} />
            <Route exact path="/technical/alerts" component={AlertsList} />
            <Route exact path="/technical/alerts/email" component={AlertsEmailList} />
            <Route exact path="/technical/alerts/personnel" component={AlertsPersonnelList} />
            <Route exact path="/technical/alerts/textcarrier" component={AlertsTextCarrierList} />
            <Route exact path="/technical/serverrouting" component={ServerRoutingList} />
            <Route exact path="/technical/distribution/systems" component={EnterpriseDistributionSystemsList} />
            <Route exact path="/technical/distributions" component={EnterpriseDistributionsList} />
            <Route exact path="/techincal/asrtestports" component={ASRTestScheduleList} />
            <Route exact path="/technical/codectypes" component={TypeCodecTypeList} />
            <Route exact path="/technical/feetypes" component={TypeFeeTypeList} />
            <Route exact path="/technical/feebases" component={TypeFeeBaseList} />
            <Route exact path="/technical/feestates" component={TypeFeeStateList} />
            <Route exact path="/technical/programgrouprules" component={PgmGroupRuleList} />
            <Route exact path="/technical/adtypes" component={TypeAdTypeList} />
            <Route exact path="/technical/risktypes" component={TypeRiskTypeList} />
            <Route exact path="/technical/routingtypes" component={TypeRoutingTypeList} />
            <Route exact path="/technical/dnistypes" component={TypeDnisTypeList} />
            <Route exact path="/technical/dnistypesummary" component={TypeDnisTypeSummList} />
            <Route exact path="/technical/traffictypes" component={TypeTrafficTypeList} />
            <Route exact path="/technical/countrycodes" component={CountrycodesList} />
            <Route exact path="/technical/timezones" component={TypeTimeZoneList} />
            <Route exact path="/technical/voicetypes" component={TypeVoiceTypeList} />
            <Route exact path="/technical/canadaroutetypes" component={TypeWsRouteCanadaTypeList} />
            <Route exact path="/technical/entitytypes" component={EntityTypeList} />
            <Route exact path="/technical/dynamicstatementvariables" component={ProgramsDynamicStatementVariablesList} />
            <Route exact path="/technical/audiomanagement" component={AudioManagementSystem} />
            <Route exact path="/technical/jobs" component={JobsList} />
            <Route exact path="/technical/dipservices" component={DipServicesList} />
            <Route exact path="/technical/dipservices/alerts" component={DipServicesAlertsList} />
            <Redirect from="/technical/*" to="/404" />

            { /* ADMIN REDIRECTS */ }
            <Redirect from="/admin/users/*" to="/admin/users" />
            <Redirect from="/admin/groups/*" to="/admin/groups" />
            <Redirect from="/admin/permissions/*" to="/admin/permissions" />
            <Redirect from="/admin/menus/*" to="/admin/menus" />
            <Redirect from="/admin/reports/*" to="/admin/reports" />
            <Redirect from="/admin/reportgroups/*" to="/admin/reportgroups" />
            <Redirect from="/admin/reportpermissions/*" to="/admin/reportpermissions" />
            <Redirect from="/admin/featuretest/*" to="/admin/featuretest" />

            { /* ADMIN ROUTES */ }
            <Route path="/admin/users" component={UsersList} />
            <Route exact path="/admin/sitepingerlogs" component={SitePingerLogsList} />
            <Route exact path="/admin/sitepinger" component={SitePingerList} />
            <Route exact path="/admin/apilogs" component={ApiLogsList} />
            <Route exact path="/admin/groups" component={GroupsList} />
            <Route exact path="/admin/permissions" component={PermissionsList} />
            <Route exact path="/admin/menus" component={MenusList} />
            <Route exact path="/admin/reports" component={AdminReportsList} />
            <Route exact path="/admin/reportgroups" component={AdminReportsGroupsList} />
            <Route exact path="/admin/reportpermissions" component={AdminReportsPermissionsList} />
            <Route exact path="/admin/featuretest" component={AdminTestFeatures} />
            <Redirect from="/admin/*" to="/404" />

            { /* Redirect to 404 if nothing else found */ }
            <Route component={LoadableError404} />

          </Switch>

        </span>
      );
    } else {
      return (
        <span className="main-container-body">
          <main>
            <Switch>
              <Route exact path="/login" component={LoadableLoginForm} />
              <Route exact path="/resetpassword" component={LoadableResetPasswordForm} />
              <Route exact path="/privacypolicy" component={LoadablePrivacyPolicy} />
              <Route exact path="/cookiepolicy" component={LoadableCookiePolicy} />
              <Route path="/setpassword" component={LoadableSetPasswordForm} />
              <Route component={LoadableLoginForm} />
            </Switch>
          </main>
        </span>
      );
    }
  }

  render() {
    return (
      <span className={ ( this.state.sidebarCollapsed ) ? 'main-container sidebar-collapsed' : 'main-container sidebar-expanded' }>
        {this.onRenderMenu()}
        {this.onRenderBody()}
      </span>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user,
        route: store.route,
        google: store.google.ReactGA,
      };
    }
  )( Container ) );



// WEBPACK FOOTER //
// ./src/presentation/Container.js